/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ReactElement } from "react";

import { Heading } from "react-bulma-components";

import { slashedYMD } from "helpers/date";
import { CommuterPass } from "models/commuterPass";
import * as Table from "molecules/Table";

export const convertTypeString = (type: any) => {
  if (type === "train") {
    return "電車";
  }
  if (type === "bus") {
    return "バス";
  }
  return "-";
};

export interface CommuterPassListProps {
  commuterPasses: CommuterPass[];
}

export function CommuterPassItem({
  id,
  type,
  lineName,
  departureNodeName,
  arrivalNodeName,
  startDate,
  endDate,
}: CommuterPass): ReactElement | null {
  return (
    <tr key={id}>
      <Table.Td>{convertTypeString(type)}</Table.Td>
      <Table.Td>{lineName}</Table.Td>
      <Table.Td>{departureNodeName}</Table.Td>
      <Table.Td>{arrivalNodeName}</Table.Td>
      <Table.Td>
        {slashedYMD(startDate)} ~ {slashedYMD(endDate)}
      </Table.Td>
    </tr>
  );
}

export function CommuterPassesList({
  commuterPasses,
}: CommuterPassListProps): ReactElement | null {
  if (commuterPasses.length >= 1) {
    return (
      <>
        <div>
          <Heading size={4}>通勤定期</Heading>
        </div>
        <Table.Table>
          <thead>
            <tr>
              <Table.Th>交通手段</Table.Th>
              <Table.Th>路線名</Table.Th>
              <Table.Th>出発地</Table.Th>
              <Table.Th>到着地</Table.Th>
              <Table.Th>期間</Table.Th>
            </tr>
          </thead>
          <tbody>
            {commuterPasses.map((commuterPass) =>
              CommuterPassItem(commuterPass)
            )}
          </tbody>
        </Table.Table>
      </>
    );
  }
  return (
    <>
      <div>
        <Heading size={4}>通勤定期</Heading>
      </div>
      <section>
        <div>通勤定期はありません</div>
      </section>
    </>
  );
}
/* eslint-enable */
